<template>
    <v-col class="pa-0">
        <!-- <v-card v-if="isLoading" class="pa-md-2 mt-2" elevation="0" width="100%">
			<LoadingSkeleton/>
		</v-card> -->
        <v-card
            v-resize="resize"
            elevation="0"
            width="100%"
            :disabled="isLoading"
            :loading="isLoading"
        >
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" lg="10">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            Ranking global de comerciales
                            <a href="#finDashboardTopComerciales">
                                <v-icon color="primary" right
                                    >mdi-arrow-down-drop-circle</v-icon
                                >
                            </a>
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                            "
                        >
                            <v-icon large> mdi-chevron-triple-up </v-icon>
                            Ranking global de comerciales
                        </div>
                    </v-col>
                    <v-col
                        cols="12"
                        lg="2"
                        :class="
                            $vuetify.breakpoint.mdAndDown
                                ? 'd-flex justify-center align-center'
                                : 'd-flex justify-end align-center'
                        "
                    >
                        <v-btn
                            small
                            color="red darken-1"
                            outlined
                            @click="goToTeletrabajo"
                        >
                            Ir a teletrabajo
                            <v-icon right>mdi-database</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <!-- <v-divider class="test"></v-divider> -->

            <v-data-table
                :headers="headers"
                :items-per-page="hasManagerPermission ? 13 : 5"
                :footer-props="footer_props"
                :items="ranking"
                class="elevation-0"
            >
                <template v-slot:item.num_ventas="{ item }">
                    <v-chip
                        class="d-flex grow justify-center flex-wrap"
                        :color="getColor(item.num_ventas)"
                        dark
                    >
                        {{ item.num_ventas }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>
        <div id="finDashboardTopComerciales"></div>
    </v-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    name: 'DashBoardTopComerciales',

    data: () => ({
        footer_props: {
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
        },
        headers: [
            {
                text: 'Nombre',
                align: 'start',
                sortable: false,
                value: 'nombre',
            },
            { text: 'Total Atenciones', value: 'atenciones' },
            { text: 'Total At. Vendidas', value: 'atenciones_vendidas' },
            { text: 'Total Ventas Valor', value: 'ventas_valor' },
            { text: 'Total Ventas', value: 'num_ventas' },
        ],
    }),
    components: {
        LoadingSkeleton,
    },
    methods: {
        getColor(ventas) {
            if (ventas < 5) return 'red';
            else if (ventas < 15) return 'orange';
            else return 'green';
        },
        resize() {
            try {
                let wellcome = document.getElementById('wellcome').offsetHeight;
                let fullHeight =
                    document.getElementById('fullHeigth').offsetHeight;
                let navBar = document.getElementById('navBar').offsetHeight;
                let adjustment = this.$store.state.login.rol != 3 ? 160 : 270;
                let numRows = parseInt(
                    (fullHeight - navBar - wellcome - adjustment) / 48
                );
                let tableLength = numRows;

                this.footer_props = {
                    disableItemsPerPage: true,
                    itemsPerPageOptions: [tableLength],
                };

                this.padding =
                    this.$store.state.login.rol != 3
                        ? 'pt-md-4 pb-md-5'
                        : 'pt-md-4 pb-md-5';
            } catch {}
        },
        goToTeletrabajo() {
            this.$router.push({ name: 'teletrabajo' });
        },
    },
    computed: {
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
        ...mapState('dashboard', {
            ranking: (state) => state.estadisticaRanking.ranking,
            isLoading: (state) => state.estadisticaRanking.isLoading,
        }),
    },
    // updated() {
    // 	this.resize();
    // },
};
</script>

<style>
.additionalPadding {
    padding-top: 6px !important;
    padding-bottom: 11px !important;
}
</style>